import { http, HttpResponse } from 'msw';
// Use relative path to interfaces barrel to avoid tsconfig exclude issues for mocks
import { EOB } from 'interfaces';

export const mockEOBs: EOB[] = [
  {
    id: 'ff08442d-46e9-47d7-b030-914d3374a54f',
    code: 'B9',
    description:
      'THIS CLAIM WAS REFUSED AS THE PROVINCE FOR THIS RECIPROCAL PATIENT IS: A) BLANK OR B) INVALID. NOTE: QUEBEC DOES NOT PARTICIPATE IN THE INTER-PROVINCIAL RECIPROCAL BILLING AGREEMENT.',
    actionType: 'R',
    actionDescription: 'PLEASE MAKE APPROPRIATE CHANGE AND RESUBMIT NEW CLAIM.',
    reviewRequired: false,
    province: 'MB',
  },

  {
    id: 'b516abd9-b92d-4c3b-9e4d-faf052d6e4b9',
    code: 'L8',
    description:
      'BENEFIT CATALOGUE ITEM WAS ADDED TO CLAIM BASED ON MANUAL ASSESSMENT OF CLAIM.',
    actionType: 'I',
    actionDescription: 'NO FURTHER ACTION REQUIRED.',
    reviewRequired: false,
    province: 'MB',
  },
  {
    id: 'b516abd9-b92d-4c3b-9e4d-faf052d6e4b9',
    code: 'L8',
    description:
      'BENEFIT CATALOGUE ITEM WAS ADDED TO CLAIM BASED ON MANUAL ASSESSMENT OF CLAIM.',
    actionType: 'I',
    actionDescription: 'NO FURTHER ACTION REQUIRED.',
    reviewRequired: false,
    province: 'MB',
  },
];

export const mockEOBCount: Record<string, number> = mockEOBs.reduce(
  (acc, e) => {
    acc[e.code] = (acc[e.code] || 0) + 1;
    return acc;
  },
  {} as Record<string, number>
);

export const mockEOBHandlers = [
  http.get('*/resource/eob/all', () => {
    return HttpResponse.json(mockEOBs, { status: 200 });
  }),
  http.get('*/resource/eob/count', () => {
    return HttpResponse.json(mockEOBCount, { status: 200 });
  }),
];
